import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ReferenceLine,
    Cell
} from 'recharts';

export default function PayVsGetChart({ data, stateName }) {
    if (!data || data.length === 0) return null;

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const ratio = payload[0].value;
            return (
                <div className="custom-tooltip" style={{ background: 'rgba(10, 15, 30, 0.9)', border: '1px solid rgba(255,255,255,0.2)', padding: '10px', borderRadius: '8px' }}>
                    <p className="label" style={{ color: '#94a3b8', margin: 0, fontSize: '0.8rem' }}>{label}</p>
                    <p className="value" style={{ color: ratio >= 1 ? '#10b981' : '#f87171', fontWeight: 'bold', margin: '4px 0' }}>
                        Return Ratio: {ratio.toFixed(2)}x
                    </p>
                    <p style={{ fontSize: '0.7rem', color: '#cbd5e1', margin: 0 }}>
                        {stateName} receives ${ratio.toFixed(2)} for every $1.00 paid.
                    </p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="chart-container state-impact-chart">
            <h3>"Pay vs Get" Ratio: {stateName}</h3>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--bg-tertiary)" vertical={false} />
                    <XAxis
                        dataKey="year"
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        tickLine={false}
                        axisLine={false}
                    />
                    <YAxis
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={(val) => `${val}x`}
                        domain={[0, 'auto']}
                        label={{ value: 'Return Multiplier', angle: -90, position: 'insideLeft', fill: 'var(--text-muted)', fontSize: '11px' }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <ReferenceLine y={1} stroke="#ef4444" strokeDasharray="3 3" label={{ position: 'right', value: 'Break Even', fill: '#ef4444', fontSize: 10 }} />
                    <Bar
                        dataKey="payVsGetRatio"
                        radius={[4, 4, 0, 0]}
                        animationDuration={1500}
                    >
                        {data.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.payVsGetRatio >= 1 ? '#10b981' : '#f87171'}
                                fillOpacity={0.8}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
